module.exports = __webpack_public_path__ + "static/img/DiscoveryPlus-Selected.2a0a6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/DiscoveryPlus-Selected.png
// module id = 1753
// module chunks = 0